import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'picnic-table', 'IconPicnicTable', [["path",{"d":"M16 7l2 9m-10 -9l-2 9m-1 -9h14m2 5h-18","key":"svg-0"}]]);